import Link from '@/update-monitor/Link'

import { Button } from '../ui/button'
import { Modal, ModalProps } from './Modal'

export const ChangePaymentMethodModal = (props: ModalProps): JSX.Element => {
  return (
    <Modal
      customStyles={{
        content: {
          padding: '48px 35px',
          width: '600px',
        },
      }}
      {...props}
    >
      <h3 className="mb-[15px] mt-[10px] text-center text-2xl font-bold tracking-widest text-primary-text">
        お支払い方法を変更しますか？
      </h3>

      <p className="mt-4 mt-[20px] px-4 text-center text-[15px] text-secondary-text">
        お支払い方法をクレジットカードに変更できます。
        <br />
        変更手続きに進みますか？
      </p>

      <Button asChild variant="secondary" className="mt-[50px] w-full">
        <Link href="/web/change-payment-method">手続きに進む</Link>
      </Button>
    </Modal>
  )
}
